import '../styles/tailwind.css'

export const Contact = () => {
    return (
      <div className="contact">
      <h2 className="contact-title text-7xl md:text-8xl text-center capitalize mb-11">contact</h2>
      <div className="contact-info block">
        <p>email: nmadani4598@gmail.com</p>
        <a href="https://www.linkedin.com/in/navid-madani-a86173266/"><p>linkedin: Navid Madani</p></a>
        <a href="https://github.com/KennyNova"><p>github: KennyNova</p></a>
      </div>
    </div>
    )
}